import React from 'react';
import { Link } from 'react-router-dom';
import SeoHead from '@components/SeoHead';

const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <SeoHead
        title="Page not found"
        description="This RoomZa page could not be found."
        path="/404"
        noindex
      />
      <div className="max-w-md w-full text-center">
        <p className="text-sm font-bold tracking-widest uppercase text-pink-600 mb-4">404</p>
        <h1 className="text-4xl font-bold text-gray-900 mb-3">Page not found</h1>
        <p className="text-gray-600 mb-8">
          The page you're looking for doesn't exist or may have moved.
        </p>
        <Link
          to="/"
          className="inline-flex h-12 items-center px-8 rounded-xl bg-gradient-to-r from-pink-500 to-rose-600 text-white font-bold hover:shadow-lg transition-all"
        >
          Back to home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
